import 'css-chunksrc/client/scenes/optimizedGantt/graph/elementsOverlay/styles.scss';export default {
  "elementsOverlay": "_elementsOverlay_1ihpe_1",
  "element": "_element_1ihpe_1"
};